// Stable IDs used as references between seed entities. Keeping them in one
// file means seed/{accounts,transactions,team,…}.ts can cross-link without
// circular imports.

export const DEMO_USER_ID = "demo-user-anna-schmidt-1111";
export const DEMO_USER_USERNAME = "anna.schmidt@contoso.demo";

export const DEMO_REGISTERED_ROLE_ID = "demo-role-registered-anna";
export const DEMO_LIVE_PERSON_ID = "demo-person-anna-schmidt";

// 5 holding entities
export const DEMO_COMPANY_HOLDINGS_AG = "demo-company-holdings-at";
export const DEMO_COMPANY_STUDIO_SRO = "demo-company-studio-cz";
export const DEMO_COMPANY_LABS_SP = "demo-company-labs-pl";
export const DEMO_COMPANY_VENTURES_GMBH = "demo-company-ventures-de";
export const DEMO_COMPANY_TRADE_LTD = "demo-company-trade-gb";

export const DEMO_COMPANY_IDS = [
  DEMO_COMPANY_HOLDINGS_AG,
  DEMO_COMPANY_STUDIO_SRO,
  DEMO_COMPANY_LABS_SP,
  DEMO_COMPANY_VENTURES_GMBH,
  DEMO_COMPANY_TRADE_LTD,
] as const;

export type DemoCompanyId = (typeof DEMO_COMPANY_IDS)[number];

// One ClientUser role per company. Used by useCompanyList() to populate
// the sidebar company switcher.
export const DEMO_CLIENT_ROLE_BY_COMPANY: Record<DemoCompanyId, string> = {
  [DEMO_COMPANY_HOLDINGS_AG]: "demo-role-client-anna-holdings",
  [DEMO_COMPANY_STUDIO_SRO]: "demo-role-client-anna-studio",
  [DEMO_COMPANY_LABS_SP]: "demo-role-client-anna-labs",
  [DEMO_COMPANY_VENTURES_GMBH]: "demo-role-client-anna-ventures",
  [DEMO_COMPANY_TRADE_LTD]: "demo-role-client-anna-trade",
};
